const isNonNullable = (_) => _ !== void 0 && _ !== null;

export { isNonNullable };
